import React, { useState, useEffect } from "react";
import { Modal, Button } from "@deere/ux.uxframe-react";
import { TextField } from "@deere/fuel-react";

export const ModalComments = ({ showModal, setShowModal, labelBtnPrimary, labelBtnSecondary, handleSubmit, titleModal, idForCommentsPopup, setIdforCommentsPopup, data }) => {
  const [comment, setComment] = useState("");
  useEffect(() => {
    if (idForCommentsPopup && idForCommentsPopup !== "") {
      let index = data ? data.findIndex((d) => d.id === idForCommentsPopup) : -1;
      if (index > -1) {
        if (data && data[index] && data[index].comments) setComment(data[index].comments);
      }
    }
  }, [idForCommentsPopup, data]);

  return (
    <Modal show={showModal} backdrop="static">
      <Modal.Header>
        <Modal.Title>{titleModal}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="overflow-hidden">
        <TextField type="text" multiline minRows={4} value={comment} onChange={(e) => setComment(e.target.value)} />
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            setComment("");
            setIdforCommentsPopup("");
            setShowModal(false);
          }}
        >
          {labelBtnSecondary}
        </Button>
        <Button
          type="submit"
          variant="primary"
          onClick={() => {
            handleSubmit(comment);
            setComment("");
            setShowModal(false);
          }}
        >
          {labelBtnPrimary}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
